import { gsap, ScrollTrigger } from 'gsap/all';
import itsMobile from '../util/is-mobile';
import { SplitText } from '../vendor/gsap/SplitText';
import { ScrollSmoother } from '../vendor/gsap/ScrollSmoother';
import smoov from '../util/smooth-scroll';

gsap.registerPlugin(ScrollTrigger, ScrollSmoother, SplitText);

smoov();

const scrollWrapper = $('.scrolly-filmstrip .scroll-wrapper');

function marqueeScroll() {
    if (itsMobile()) {
        gsap.set(scrollWrapper, { x: '5vw' });
        const marqueeTween = gsap.timeline({
            scrollTrigger: {
                trigger: '.marquee-horizontal-scroll-panel',
                scrub: true,
                start: 'top bottom',
                end: 'bottom top',
            },
        });

        marqueeTween.to(scrollWrapper, {
            x: '-=105vw',
        });
    } else {
        gsap.set(scrollWrapper, { x: '-5vw' });
        const marqueeTween = gsap.timeline({
            scrollTrigger: {
                trigger: '.marquee-horizontal-scroll-panel',
                scrub: true,
                start: 'top bottom',
                end: 'bottom top',
            },
        });

        marqueeTween.to(scrollWrapper, {
            x: '-=15vw',
        });
    }
}

if ($(scrollWrapper).length) {
    marqueeScroll();
}

// const rightHeight = '';
function getHeight() {
    const bmcHeight = $('.services-bmc-wrapper').height();
    const windowHeight = $('.services-bmc-item#last-item').height();
    const calcHeight = bmcHeight - windowHeight;
    const renderedHeight = `+=${calcHeight}px`;

    return renderedHeight;
}

$(window).on('resize', () => {
    getHeight();
    ScrollTrigger.refresh();
});

if (!itsMobile()) {
    // Function to split panel with left side pinning circle that transforms on update to new panel

    // bmc vars
    const bmcCircleWrapper = $('.services-circle-wrapper');
    const item = $('.services-bmc-item');
    const copyFades = gsap.utils.toArray('.js-copy-fade');

    // copyFades.forEach((copy) => {
    //     gsap.set(copy, { opacity: 0 });
    //     ScrollTrigger.create({
    //         trigger: copy,
    //         start: 'top 50%',
    //         end: 'bottom 59%',
    //         onToggle: (self) => {
    //             if (self.isActive) {
    //                 gsap.to(copy, { duration: 1, opacity: 1 });
    //             } else {
    //                 gsap.to(copy, { duration: 0.3, opacity: 0 });
    //             }
    //         },
    //     });
    // });

    // gsap.utils.toArray(item).forEach((elem) => {
    //     const matchingCircle = $(elem).attr('data-bmc-service');
    //     const matchingIdNoChild = $(`#${matchingCircle}:not(:last-child)`);
    //     const textTitle = $(`#${matchingCircle}`).find('.service-name');

    //     gsap.set('.services-circle-wrapper .services-circle-item', { zIndex: (i, target, targets) => targets.length - i });

    //     // Triggering each service title animation with the 'elem' parent when it hits 50%, maybe I should set earlier
    //     const circleTl = gsap.timeline({
    //         paused: true,
    //     });

    //     gsap.set(textTitle, { xPercent: -120, opacity: 0 });

    //     // Slide in the service title
    //     gsap.to(textTitle, {
    //         xPercent: 0,
    //         opacity: 1,
    //         ease: 'none',
    //         scrollTrigger: {
    //             trigger: elem,
    //             start: 'top bottom',
    //             end: 'top 50%',
    //             scrub: true,
    //         },
    //     });

    //     // For the circles sliding vertically away
    //     gsap.to(matchingIdNoChild, {
    //         yPercent: -200,
    //         ease: 'none',
    //         stagger: 0.5,
    //         transform: 'translateY(-50%)',
    //         scrollTrigger: {
    //             trigger: elem,
    //             start: 'top top',
    //             end: 'bottom top',
    //             scrub: true,
    //             invalidateOnRefresh: true,
    //         },
    //     });

    //     return circleTl;
    // });

    // Get proper height to unpin after #last-item (creative circle)

    ScrollTrigger.create({
        trigger: bmcCircleWrapper,
        start: 'top top+=200px',
        end: getHeight(),
        pin: true,
        anticipatePin: true,
        invalidateOnRefresh: true,
    });
} // If not mobile

// Animate bullet points
const serviceLi = $('.service-list');

gsap.utils.toArray(serviceLi).forEach((elem) => {
    const listItem = $(elem).find('li');

    gsap.set(listItem, {
        paddingLeft: '40px',
        opacity: 0,
    });

    const listTl = gsap.timeline({
        paused: true,

        scrollTrigger: {
            trigger: elem,
            start: 'top 90%',
            end: 'bottom 50%',
        },
    });

    listTl.to(listItem, {
        duration: 0.3,
        ease: 'power.2',
        paddingLeft: '1.5rem',
        opacity: 1,
        stagger: 0.25,
    });

    return listTl;
});

// Scrolling text marquee with yellow (turbo) bg
const turboTween = gsap.to('.marquee__part', {
    xPercent: -100, repeat: -1, duration: 20, ease: 'linear',
}).totalProgress(0.5);

gsap.set('.marquee__inner', { xPercent: -25 });

function tileTweener() {
    const marqueeTween = gsap.timeline({
        scrollTrigger: {
            trigger: '.scrolling-marquee',
            scrub: true,
            start: 'top bottom',
            end: 'bottom top',
            invalidateOnRefresh: true,
            onEnter: () => { turboTween.play(); },
            onEnterBack: () => {
                turboTween.play();
            },
            onLeave: () => {
                turboTween.pause();
            },
            onUpdate: (self) => {
                if (self.direction === 1) {
                    gsap.to(turboTween, {
                        timeScale: 1,
                    });
                } else {
                    gsap.to(turboTween, {
                        timeScale: -1,
                    });
                }
            },
        },
    });

    return marqueeTween;
}

tileTweener();
